import { useContext } from "react";
import { OrganizationContext } from "../context/organization.context";

export default function useOrganization() {
    const context = useContext(OrganizationContext);
    if (!context) {
        throw new Error("useOrganization must be used within a OrganizationLayout");
    }
    return context
}